'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
exports.default = controlFields;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _lodash = require('lodash');
var _validation = require('../actions/validation');
var _updateFields = require('../actions/update-fields');
var _formInfo = require('../selectors/form-info');
var _withFormValidator = require('./with-form-validator');
var _withFormValidator2 = _interopRequireDefault(_withFormValidator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function controlFields(WrappedField) {
  var ControlFields = function (_Component) {
    _inherits(ControlFields, _Component);
    function ControlFields() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck(this, ControlFields);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ControlFields.__proto__ || Object.getPrototypeOf(ControlFields)).call.apply(_ref, [this].concat(args))), _this), _this.control = function (values) {
        _this.props.setValues(_this.props.formId, values);
      }, _this.validate = function (name) {
        _this.props.validateField(_this.props.formId, name, _this.props.validate[name]);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(ControlFields, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedField, Object.assign({}, (0, _lodash.omit)(this.props, ['valueUndefined', 'defaultValue', 'setValue', 'validateField']), {
          formId: this.props.formId,
          validate: this.validate,
          control: this.control
        }));
      }
    }]);
    return ControlFields;
  }(_react.Component);
  ControlFields.propTypes = {
    // withFormContext
    formId: _propTypes.string.isRequired,
    validate: _propTypes.object,
    // dispatchToProps
    setValues: _propTypes.func.isRequired,
    validateField: _propTypes.func.isRequired
  };
  ControlFields.defaultProps = {
    validate: undefined
  };
  return (0, _withFormValidator2.default)((0, _reactRedux.connect)(function (state, ownProps) {
    return {
      values: (0, _formInfo.getValues)(state, ownProps.formId),
      errors: (0, _formInfo.getErrors)(state, ownProps.formId),
      validating: (0, _formInfo.getValidating)(state, ownProps.formId)
    };
  }, {
    setValues: _updateFields.setValues,
    validateField: _validation.validateField
  })(ControlFields));
}